import { Alert, AlertDescription } from '@/components/ui/alert';
import clsx from 'clsx';
import React from 'react';
import validationErrorStyles from './validation-error.module.scss';

export type ValidationError = {
  field?: string;
  messages: string[];
};

type ValidationErrorComponentProps = {
  errors: ValidationError[];
  title?: string;
};

export const ValidationErrorComponent = ({ errors, title }: ValidationErrorComponentProps): React.JSX.Element | null => {
  const getValidationError = (validationError: { field?: string; messages: string[]; }): string => {
    return validationError.messages.map(message => `${validationError.field ? `${validationError.field} ` : ''}${message}`).join(' ');
  };

  if (!errors.length) return null;

  return <>
    {!!errors.length &&
      <Alert className={validationErrorStyles['validation-errors']}
        data-test="validation-errors"
        variant="destructive"
      >
        <AlertDescription>
          {title && <h3 data-test="validation-errors-title">{title}</h3>}
          <ul className={clsx('list-disc', title ? 'ml-md' : '')}>
            {errors.map((error, index) =>
              <li key={error.field || index}
                data-test="validation-errors-item-error"
              >
                {getValidationError(error)}
              </li>
            )}
          </ul>
        </AlertDescription>
      </Alert>
    }
  </>;
};
